<template>
  <div class="cl-inner">
    <div v-if="!showSetting">
      <!-- 搜索 -->
      <div class="search-inner">
        <a-form layout="inline">
          <a-form-item class="name" label="教育局名称">
            <a-input class="form-cell" type="text" v-model="queryParam.bureauName"></a-input>
          </a-form-item>
          <a-form-item label="地区" class="form-oper" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
            <a-cascader v-if="$store.state.common.address.length > 0" class="form-cell"
              :options="$store.state.common.address" placeholder="请选择" changeOnSelect v-model="queryParam.addressSelect"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }" />
          </a-form-item>
          <a-form-item class="search-oper">
            <a-button type="primary" @click="searchBureau()">查询</a-button>
            <a-button type="primary" @click="() => (queryParam = {})">重置</a-button>
          </a-form-item>
        </a-form>
      </div>

      <!-- 操作 -->
      <div class="list-oper">
        <a-button type="primary" icon="plus" @click="$refs.bureauForm.init('add')">新建</a-button>
      </div>

      <!-- 表格数据 -->
      <a-table :columns="columns" :dataSource="bureauList" class="c-table" :pagination="pagination" :loading="loading"
        @change="tableChange" :rowKey="getRowKey">
        <span slot="id"></span>
        <span slot="bureauName"></span>
        <span slot="address" slot-scope="text, record">
          <template>
            <span>{{ record.provinceId | codeFilter }}{{ record.cityId | codeFilter
            }}{{ record.districtId | codeFilter }}</span>
          </template>
        </span>
        <span slot="gmtCreate"></span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a @click="goBureauSetting(record)">设置</a>
            <a-divider type="vertical" />
            <a @click="$refs.customSetting.init(record)">个性化</a>
            <a-divider type="vertical" />
            <a @click="$refs.bureauForm.init('update', record)">修改</a>
            <a-divider type="vertical" />
            <a @click="deleteBureau(record)">删除</a>
          </template>
        </span>
      </a-table>
      <bureau-form-modal ref="bureauForm" @addBureau="addBureau" @updateBureau="updateBureau"></bureau-form-modal>

      <custom-setting ref="customSetting" @updateBureau="updateBureau"></custom-setting>
    </div>
    <div v-else>
      <div style="margin-bottom: 24px;">
        <a @click="back" style="color: #000000A6;"><a-icon type="arrow-left" /> 返回</a>
      </div>
      <a-table :columns="settingColumns" :dataSource="settingData" :pagination="false">
        <template slot="settingKey" slot-scope="text, record">
          <a-popover>
            <template slot="content">
              <p>{{ record.settingKey }}</p>
            </template>
            <div class="ellipsis">{{ record.settingKey }}</div>
          </a-popover>
        </template>
        <template slot="defaultSettingValue" slot-scope="text, record">
          <a-popover :overlayStyle="{maxWidth: '300px'}">
            <template slot="content">
              <p>{{ record.defaultSettingValue }}</p>
            </template>
            <div class="ellipsis">{{ record.defaultSettingValue }}</div>
          </a-popover>
        </template>
        <template slot="comment" slot-scope="text, record">
          <a-popover>
            <template slot="content">
              <p>{{ record.comment }}</p>
            </template>
            <div class="ellipsis">{{ record.comment }}</div>
          </a-popover>
        </template>
        <template slot="settingValue" slot-scope="text, record">
          <a-popover :overlayStyle="{maxWidth: '300px'}">
            <template slot="content">
              <p>{{ record.settingValue }}</p>
            </template>
            <div class="ellipsis">{{ record.settingValue }}</div>
          </a-popover>
        </template>
        <template slot="oper" slot-scope="text, record">
          <template>
            <a @click="edit(record)">修改</a>
          </template>
        </template>
      </a-table>
    </div>
    <a-modal v-model="visible" title="修改教育局站点设置" @cancel="close" width="600px" @ok="handleSubmit">
      <div class="modal">
        <div class="line">
          <div class="label">教育局站点:</div>
          <a-input type="text" readOnly class="gray" v-model="currentItem.bureauName" />
        </div>
        <div class="line">
          <div class="label">设定项:</div>
          <a-input type="text" readOnly class="gray" v-model="settingItem.settingKey" />
        </div>
        <div class="line">
          <div class="label">默认值:</div>
          <a-textarea readOnly :rows="3" class="gray" v-model="settingItem.defaultSettingValue" />
        </div>
        <div class="line">
          <div class="label">说明:</div>
          <a-textarea readOnly :rows="3" class="gray" v-model="settingItem.comment" />
        </div>
        <div class="line">
          <div class="label">教育局设定值:</div>
          <a-textarea :rows="4" v-model.trim="newSettingValue" />
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import CTable from '../../components/CTable'

import bureau from '../../api/bureau'

import BureauFormModal from './BureauFormModal'

import { analysisAddress } from '../../utils/address'

import CustomSetting from './components/CustomSetting'

import dayjs from 'dayjs'

const columns = [
  {
    title: '教育局名称',
    dataIndex: 'bureauName',
    key: 'bureauName',
  },
  {
    title: '负责人',
    dataIndex: 'nickname',
    key: 'nickname',
  },
  {
    title: '域名',
    dataIndex: 'domainName',
    key: 'domainName',
  },
  {
    title: '地区',
    dataIndex: 'address',
    key: 'address',
    scopedSlots: { customRender: 'address' },
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    key: 'gmtCreate',
    sorter: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]
const settingColumns = [
  {
    title: '设定项',
    dataIndex: 'settingKey',
    width: 180,
    key: 'settingKey',
    scopedSlots: { customRender: 'settingKey' },
    sorter: (a, b) => a.settingKey.localeCompare(b.settingKey),
  },
  {
    title: '默认值',
    dataIndex: 'defaultSettingValue',
    key: 'defaultSettingValue',
    scopedSlots: { customRender: 'defaultSettingValue' },
  },
  {
    title: '说明',
    dataIndex: 'comment',
    key: 'comment',
    scopedSlots: { customRender: 'comment' },
  },
  {
    title: '教育局设定值',
    dataIndex: 'settingValue',
    key: 'settingValue',
    scopedSlots: { customRender: 'settingValue' },
  },
  {
    title: '修改时间',
    dataIndex: 'gmtModified',
    // width: 180,
    key: 'gmtModified',
    sorter: (a, b) => new Date(dayjs(a.gmtModified)).getTime() - new Date(dayjs(b.gmtModified)).getTime(),
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'oper' },
    width: 60,
  },
]

export default {
  name: 'bureauList',
  data() {
    return {
      bureauList: [], //教育数据
      columns, //列标识数据
      queryParam: {}, //查询参数
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
      }, //分页数据对象
      loading: true,
      showSetting: false,
      settingColumns,
      settingData: [],
      currentItem: {},
      visible: false,
      settingItem: {},
      newSettingValue: ''
    }
  },
  components: {
    CTable,
    BureauFormModal,
    CustomSetting,
  },
  methods: {
    getRowKey(record, index) {
      return index;
    },
    //修改一个教育局
    updateBureau(bureau) {
      for (let i in this.bureauList) {
        if (this.bureauList[i].id == bureau.id) {
          this.$set(this.bureauList, i, bureau)
        }
      }
    },

    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地区的话，把地区解析之后带入
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = pagination.current
      // window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
      //   obj
      // )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${sorter.order == 'ascend' ? 'asc' : 'desc'
          }`
      }
      this.getBureauList(obj)
    },

    //新增一个教育局
    addBureau(bureau) {
      this.bureauList.unshift(bureau)
    },
    goBureauSetting(item) {
      console.log(item)
      this.showSetting = true
      this.currentItem = item
      this.getBureauInfo(item.id)
    },
    getBureauInfo(id) {
      bureau.getBureauSettingList({ bureauId: id }).then(res => {
        this.settingData = res.data
        console.log(this.settingData)
      })
    },
    //删除教育局
    deleteBureau(value) {
      let self = this
      this.$confirm({
        title: '确定要删除吗?',
        okText: '确定',
        cancelText: '取消',
        content: '删除后，无法撤销',
        onOk() {
          bureau.deleteBureau(value.id).then((res) => {
            self.$message.success('删除成功')
            //前端模拟删除
            self.deleteBureauData(self.bureauList, value.id)
          })
        },
      })
    },

    //删除数据
    deleteBureauData(data, id) {
      for (let i in data) {
        if (data[i].id == id) {
          data.splice(i, 1)
          break
        }
      }
    },

    //查询教育局
    searchBureau() {
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = 1
      // window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
      //   obj
      // )}`
      this.getBureauList(obj)
    },

    //教育局列表
    getBureauList(params) {
      this.loading = true
      bureau.getBureauList(params).then((res) => {
        console.log('当前的教育局列表是', res.data.list)
        this.bureauList = res.data.list
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },
    back() {
      this.showSetting = false
    },
    edit(item) {
      this.visible = true
      this.settingItem = JSON.parse(JSON.stringify(item))
      if (!item.defaultSettingValue) this.settingItem.defaultSettingValue = '暂无'
      if (!item.comment) this.settingItem.comment = '暂无'
      this.newSettingValue = item.settingValue
    },
    close() {
      this.visible = false
      this.settingItem = {}
      this.newSettingValue = ''
    },
    handleSubmit() {
      if (!this.newSettingValue) {
        this.$message.error('请填写教育局设定值')
        return
      }
      console.log(this.newSettingValue, this.settingItem.id, this.currentItem.id)
      let params = {
        bureauId: this.currentItem.id,
        settingId: this.settingItem.id,
        settingValue: this.newSettingValue
      }
      bureau.updateBureauSettingValue(params).then(res => {
        this.$message.success('修改成功')
        this.close()
        this.getBureauInfo(this.currentItem.id)
      })

    }
  },
  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
      let arr = []
      if (this.queryParam.provinceId) {
        arr[0] = this.queryParam.provinceId
      }
      if (this.queryParam.cityId) {
        arr[1] = this.queryParam.cityId
      }
      if (this.queryParam.districtId) {
        arr[2] = this.queryParam.districtId
      }
      this.queryParam.addressSelect = arr
    } else {
      this.queryParam = {}
    }
    this.getBureauList(this.queryParam)
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}

.search-oper {
  button {
    margin: 0px 5px;
  }
}

.list-oper {
  margin: 20px 0px 30px;
}

.modal {
  padding-right: 12px;

  .line {
    display: flex;
    margin-bottom: 12px;

    .label {
      width: 120px;
      text-align: right;
      line-height: 32px;
      margin-right: 10px;
    }

    textarea {
      resize: none;
    }
  }

  .gray {
    background: #f0f0f0;
  }
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 15vw;
  min-width: 100px;
}
</style>
